<div class="grid" [formGroup]="createTokenForm">
    <div class="col-12 md:col-6">
        <div class="card p-fluid">
            <h4>Dispatch Detail</h4>
            <div class="p-formgrid grid">
                <div class="field col">
                    <label><strong> Purpose<span class="required-asterisk">*</span></strong></label>
                    <p-dropdown [options]="purpose" placeholder="Select purpose" formControlName="purpose"
                        (onChange)="onChangePurposeVlaue($event.value)"></p-dropdown>
                </div>
                <div class="field col">
                    <label><strong> Plant<span class="required-asterisk">*</span></strong></label>
                    <!-- <input pInputText formControlName="plant" /> -->
                    <p-dropdown [options]="plantList" placeholder="Select Gate" (onChange)="getSelectetdPlant($event.value)" formControlName="plant"
                         optionLabel="name" optionValue="name"></p-dropdown>
                </div>
                <div class="field col">
                    <label><strong> Gate<span class="required-asterisk">*</span></strong></label>
                    <!-- <input pInputText formControlName="gate" /> -->
                    <p-dropdown [options]="gateList" placeholder="Select Gate" formControlName="gate"
                    optionLabel="name" optionValue="name" ></p-dropdown>
                </div>
            </div>
            <div class="p-formgrid grid">
                <div class="field col">
                    <label><strong> Loading/Unloading Point</strong></label>
                    <p-dropdown [options]="getLoadingAndUnloadingPoint" placeholder="Select value"
                        formControlName="loading_unloading_point"></p-dropdown>
                </div>
                <div class="field col">
                    <label><strong> Vendor</strong></label>
                    <p-dropdown [options]="vendor_list" placeholder="Select Vendor"
                     (onChange)="getselectedVendorPoList($event.value)" optionLabel="vendor_code" optionValue="vendor_code" formControlName="vendor"></p-dropdown>
                </div>
            </div>
            <h4>PO / Invoice Detail</h4>
            <div class="p-formgrid grid">
                <div class="field col">
                    <input type="radio" formControlName="ingredient" value="isPO" (click)="onIngredientChange('isPO')">
                    <label><strong> By PO</strong></label>
                </div>
                <div class="field col">
                    <input type="radio" formControlName="ingredient" value="isASN"
                        (click)="onIngredientChange('isASN')">
                    <label><strong> By ASN</strong></label>
                </div>
            </div>
            <div *ngIf="byPO" class="p-formgrid grid">
                <div class="field col">
                    <label><strong> Po/Agreement No</strong></label>
                    <p-multiSelect [options]="all_po_list" formControlName="poagreement_no" optionLabel="name"
                        placeholder="Select PO" (onChange)="onMultiSelectChange($event)"></p-multiSelect>
                </div>
                <div class="field col">
                    <label><strong> Invoice/ Challan No</strong></label>

                    <input pInputText formControlName="asn_no" />
                </div>
            </div>
            <div *ngIf="byASN" class="p-formgrid grid">
                <div class="field col">
                    <label><strong> Invoice/ Challan No</strong></label>
                    <p-dropdown placeholder="Select Invoice/ Challan No" formControlName="asn_no" [options]="asnNo"
                        optionLabel="invoice_challan_no" optionValue="invoice" (onChange)="onAsnNoSelected($event.value)"></p-dropdown>
                </div>
                <div class="field col">
                    <label><strong> Po/Agreement No</strong></label>
                    <input pInputText formControlName="poagreement_no" />
                </div>
            </div>
            <div class="p-formgrid grid">
                <div class="field col">
                    <p-button label="Submit" (click)="onSubmit()" [disabled]="!disableSubmit"></p-button>&nbsp;&nbsp;
                </div>
                <div class="field col">
                    <p-button *ngIf="isDownload" label="Print" (click)="generatePdfWithQRCode()"></p-button>
                </div>
                <div class="field col">
                </div>
            </div>
        </div>
    </div>

    <div class="col-12 md:col-6">
        <div class="card p-fluid">
            <h4>Driver Detail</h4>
            <div class="p-formgrid grid">
                <div class="field col">
                    <label><strong> Driver Name</strong></label>
                    <p-dropdown placeholder="Select Driver" formControlName="driver_name" [options]="driver_list"
                        optionLabel="name" optionValue="name" (onChange)="onDriverChange($event.value)"></p-dropdown>
                </div>
                <div class="field col">
                    <label><strong> Driver Mobile No </strong></label>
                    <input pInputText formControlName="driver_mobile_no" />
                </div>
            </div>
            <div class="p-formgrid grid">
                <div class="field col">
                    <label><strong> Vehicle No </strong></label>
                    <p-dropdown placeholder="Select Vehicle" formControlName="vehicle_no" [options]="vehicle_list"
                        optionLabel="name" optionValue="name"></p-dropdown>
                </div>
                <div class="field col">
                    <label>Vehicle Type<span class="required-asterisk">*</span></label>
                    <p-dropdown [options]="vehicleTypeList" placeholder="Vehicle Type"
                        formControlName="vehicle_type"></p-dropdown>
                </div>
            </div>
            <h4>Other Detail</h4>
            <div class="p-formgrid grid">
                <div class="field col">
                    <label><strong> Print Date and Time<span class="required-asterisk">*</span></strong></label>
                    <p-calendar [iconDisplay]="'input'" [showIcon]="true" dateFormat="dd/mm/yy" [minDate]="minDateValue"
                        [showButtonBar]="true" [showTime]="true" [showSeconds]="true"
                        formControlName="print_date_and_time"></p-calendar>
                </div>
                <div class="field col">
                    <label><strong> Remark</strong></label>
                    <input pInputText formControlName="remark" />
                </div>
            </div>
            <div class="p-formgrid grid">
                <div class="field col">
                </div>
                <div class="field col">
                </div>
            </div>
        </div>
    </div>
</div>
<p-toast></p-toast>
